import {Database} from "./database";
import {Media} from "./media";
import {User} from "./user";

export class Project {
    _id: string;
    name: string;
    user_id: string;
    databases: Array<Database>;
    media: Array<Media>;
    user: User;

    constructor(data) {

        this._id = data._id;
        this.user_id = data.user_id;
        this.name = data.name;
        this.databases = data.databases ? data.databases.map(database => new Database(database)) : [];
        this.media = data.media ? data.media.map(m => new Media(m)) : [];
        this.user = data.user || null
    }

    getObj() {
        return {
            name: this.name
        }
    }
}
